import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';

import { loadExternalAccountsSchema } from './actions';

import Route from '../../routes/SentryRoute';
import { BrivoUsersCleanupRoutes } from './BrivoUsersCleanup/BrivoUsersCleanupRoutes';
import { ExternalAccountForm } from './ExternalAccountForm';
import { ExternalAccountTable } from './ExternalAccountTable';
import { ExternalAccountsList } from './ExternalAccountsList';
import { ExternalLinksRoutes } from './ExternalLinks/ExternalLinksRoutes';

export const ExternalAccounts = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const loadSchema = async () => {
    const res = await loadExternalAccountsSchema(dispatch);
    if (!res?.data?.enabled) history.push('/external-accounts-v1');
  };

  useEffect(() => {
    loadSchema();
  }, []);

  return (
    <Switch>
      <Route
        path={`${match.path}/brivo/clear-users`}
        component={BrivoUsersCleanupRoutes}
      />
      <Route
        path={`${match.path}/external-links`}
        component={ExternalLinksRoutes}
      />
      <Route path={`${match.path}/:type/:id`} component={ExternalAccountForm} />
      <Route path={`${match.path}/:type`} component={ExternalAccountTable} />
      <Route path={`${match.path}/`} component={ExternalAccountsList} />
    </Switch>
  );
};

ExternalAccounts.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};
